import Big from "big.js";


const MATH_HELPER = {
    numberWithDigit(number, digit) {
        try {
            return Big(number)?.toFixed(8)
        } catch (e) {
            return '';
        }
    },

    isNumeric(value) {
        return /^\d*\.?\d*$/.test(value);
    },

    isPositive(value) {
        return parseFloat(value || 0) > 0
    },

    formatAsset(num) {
        return parseFloat(num).toLocaleString('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}


export default MATH_HELPER
